import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const claimed = Math.round((TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100);
  return <div className="w-full rounded-2xl border-2 border-alert/30 bg-red-50 p-4" data-id="element-311" data-mp="2l2tq4fk15fn2">
      <div className="flex items-center justify-between gap-3" data-id="element-312" data-mp="2q2g10icdyjsp">
        <p className="flex items-center gap-1.5 text-sm font-extrabold text-red-700" data-id="element-313" data-mp="2b6gx7jwb75td">
          <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-314" data-mp="2g6crusj49kw9" />
          Only {SPOTS_LEFT} spots left at $27
        </p>
        <span className="text-sm font-black text-red-700" data-id="element-315" data-mp="227deih120sfe">{claimed}% claimed</span>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-red-200" role="progressbar" aria-valuenow={claimed} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-316" data-mp="2766gpdaw4x09">
        <motion.div className="h-full rounded-full bg-alert" initial={{
        width: '0%'
      }} whileInView={{
        width: `${claimed}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-317" data-mp="33mv8ioabtj7u" />
      </div>
      <p className="mt-2 text-xs font-medium text-red-800" data-id="element-318" data-mp="3desjbtxfa961">
        When the remaining spots are gone, the price returns to its regular value.
      </p>
    </div>;
}